export default "__VITE_ASSET__BJi6P2uG__"